const ASSIGNMENT_STATUS = {
  UNASSIGNED: 'Unassigned',
  COMPLETED: 'Completed',
  IN_PROGRESS: 'In Progress',
  MISSED: 'Missed',
  NOT_STARTED: '',
  NOT_ASSIGNED: 'Not Assigned'
};

const SEARCH_TYPES = {
  STUDENT: 'STUDENT',
  ASSIGNMENTS: 'ASSIGNMENTS'
};

const VISIBILITY_OPTIONS = {
  NONE: 'none',
  CUSTOM: 'custom',
  ALL: 'all',
  DAYS_BEFORE: 'daysBefore',
  INDIVIDUAL: 'individual' // for batch assign purposes
};

const GRADEBOOK_SETTINGS = {
  reportInProgressAssignments: 1,
  reportOnlyDueDatePassedAssignments: 2,
  gradingTypeStandard: 3,
  gradingTypeWeighted: 4,
  roundPercentWhole: 5,
  roundPercentTenths: 6,
  roundPercentHundredths: 7
};

const EXPORT_EACH_STUDENT_OPTIONS = {
  ALL_GRADES: 'ALL_GRADES',
  COURSE_AND_CATEGORY: 'COURSE_AND_CATEGORY'
};

const EXPORT_GRADE_FORMAT_OPTIONS = {
  POINTS: 'POINTS',
  PERCENTAGES: 'PERCENTAGES'
};

const EXPORT_OPTIONS = {
  EACH_STUDENT: EXPORT_EACH_STUDENT_OPTIONS.ALL_GRADES,
  GRADE_FORMAT: EXPORT_GRADE_FORMAT_OPTIONS.POINTS,
  INCLUDE_COL_AVG: false,
  INCLUDE_STUDENT_ID: false
};

const GRADING_TYPE = {
  GRADED: 1,
  UNGRADED: 2,
  EXTRA_CREDIT: 3
};

const GRADEBOOK_SORT = {
  LODASH_ASCENDING: 'asc',
  LODASH_DESCENDING: 'desc',
  DEFAULT_SORT_DIRECTION: 'asc',
  NAME_SORT_COLUMN: 'NAME_SORT_COLUMN'
};

const GRADEBOOK_GRADING_TYPES = [
  { value: 1, label: 'Graded' },
  { value: 2, label: 'Ungraded' },
  { value: 3, label: 'Extra Credit' }
];

const GRADEBOOK_GRADING_TYPES_GRADED = GRADEBOOK_GRADING_TYPES[0].value;
const GRADEBOOK_GRADING_TYPES_UNGRADED =
  GRADEBOOK_GRADING_TYPES[1].value;
const GRADEBOOK_GRADING_TYPES_EXTRA_CREDIT =
  GRADEBOOK_GRADING_TYPES[2].value;

const GRADEBOOK_GRADING_TYPES_GRADED_LABEL =
  GRADEBOOK_GRADING_TYPES[0].label;
const GRADEBOOK_GRADING_TYPES_UNGRADED_LABEL =
  GRADEBOOK_GRADING_TYPES[1].label;
const GRADEBOOK_GRADING_TYPES_EXTRA_CREDIT_LABEL =
  GRADEBOOK_GRADING_TYPES[2].label;

// Used for export
const GRADING_TYPES = Object.freeze({
  graded: GRADEBOOK_GRADING_TYPES_GRADED,
  ungraded: GRADEBOOK_GRADING_TYPES_UNGRADED,
  extra_credit: GRADEBOOK_GRADING_TYPES_EXTRA_CREDIT
});

const GRADEBOOK_GRADING_TYPES_CHAR_LIMIT = 17;

const IS_DRAFT = {
  draft: true
};

const NGA_SUBTYPES = {
  SHORT_FORM_WRITING: 'short-form-writing',
  GUIDED_READING: 'cca'
};

const RESOURCE_TYPE_FILTER = {
  TOOL: 'tool',
  LABEL: 'label',
  SUBTYPE: 'subtype'
};

const constants = {
  ASSIGNMENT_STATUS,
  SEARCH_TYPES,
  VISIBILITY_OPTIONS,
  GRADEBOOK_SETTINGS,
  EXPORT_OPTIONS,
  GRADING_TYPE,
  GRADEBOOK_SORT,
  GRADEBOOK_GRADING_TYPES_GRADED_LABEL,
  GRADEBOOK_GRADING_TYPES_UNGRADED_LABEL,
  GRADEBOOK_GRADING_TYPES_EXTRA_CREDIT_LABEL,
  GRADING_TYPES,
  GRADEBOOK_GRADING_TYPES_CHAR_LIMIT,
  GRADEBOOK_GRADING_TYPES_EXTRA_CREDIT,
  IS_DRAFT,
  NGA_SUBTYPES,
  RESOURCE_TYPE_FILTER
}

export {
  ASSIGNMENT_STATUS,
  SEARCH_TYPES,
  VISIBILITY_OPTIONS,
  GRADEBOOK_SETTINGS,
  EXPORT_OPTIONS,
  GRADING_TYPE,
  GRADEBOOK_SORT,
  GRADEBOOK_GRADING_TYPES_GRADED_LABEL,
  GRADEBOOK_GRADING_TYPES_UNGRADED_LABEL,
  GRADEBOOK_GRADING_TYPES_EXTRA_CREDIT_LABEL,
  GRADING_TYPES,
  GRADEBOOK_GRADING_TYPES_CHAR_LIMIT,
  GRADEBOOK_GRADING_TYPES_EXTRA_CREDIT,
  IS_DRAFT,
  NGA_SUBTYPES,
  RESOURCE_TYPE_FILTER
};

export default constants;
